import { FieldValues } from "react-hook-form";
import { Input, InputProps } from "./Input";
import { Select, SelectProps } from "./Select";

export type TForm<T extends FieldValues> = {
	Input: (props: InputProps<T>) => JSX.Element;
	Select: (props: SelectProps<T>) => JSX.Element;
};

export function createForm<T extends FieldValues>(): TForm<T> {
	return {
		Input: Input<T>,
		Select: Select<T>,
	};
}
